<app-breadcrumb></app-breadcrumb>

<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="d-flex gap-4 align-items-top justify-content-end">
    <div class="backIconContiner" (click)="goBack()" matTooltip="Go back">
        <i class="fa fa-arrow-left"></i>
    </div>
</div>

<div class="menu">
    <div class="row">
        <mat-radio-group [(ngModel)]="selectedTrailCriteria" (change)="onCriteriaChange()">
            <mat-radio-button color="primary" *ngFor="let criteria of trailCriteria"
                [value]="criteria">{{criteria}}</mat-radio-button>
        </mat-radio-group>
    </div> <br>

    <div class="menu-panel" [ngSwitch]="selectedTrailCriteria">
        <ng-container *ngSwitchCase="'Training Master'">
            <div class="row slide-top">
                <div class="col-md-6">
                    <div> <label for="email" id="training-name">Training Name </label> </div>
                    <div class="row align-items-center">
                        <div class="col-md-11">
                            <input class="form-control input-filed-continers" style="cursor: not-allowed;" type="text"
                                [(ngModel)]="pickedTraining.trainingName"
                                (ngModelChange)="onNgModelChange($event,'field-name')" disabled>
                        </div>
                        <div class="col-md-1" style="cursor: pointer">
                            <img src="../../assets/img/search-user.svg" width="34px" height="34px" alt="add new"
                                *ngIf="!pickedTraining.trainingName" (click)="openSearchPopup('Training(s)')" />
                            <img src="../../assets/img/clear.svg" width="34px" height="34px" alt="add new"
                                *ngIf="pickedTraining.trainingName" (click)="primaryReset()" />
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="'User Training'">
            <div class="row slide-top">
                <div class="col-md-6">
                    <div> <label for="email" id="training-name">Training User </label> </div>
                    <div class="row align-items-center">
                        <div class="col-md-11">
                            <input class="form-control input-filed-continers" style="cursor: not-allowed;" type="text"
                                [(ngModel)]="pickedUser.userName" (ngModelChange)="onNgModelChange($event,'field-name')"
                                [disabled]="true">
                        </div>
                        <div class="col-md-1" style="cursor: pointer">
                            <img *ngIf="!pickedUser.userName" src="../../assets/img/search-user.svg" width="34px"
                                height="34px" alt="add new" (click)="openSearchPopup('User(s)')" />
                            <img src="../../assets/img/clear.svg" width="34px" height="34px" alt="add new"
                                *ngIf="pickedUser.userName" (click)="primaryReset()" />
                        </div>
                    </div>
                </div>
                <div class="col-md-6" *ngIf="pickedUser && (pickedUser | json) !== '{}'">
                    <div> <label for="email" id="training-name">Training(s) </label> </div>
                    <div class="row align-items-center">
                        <mat-select matInput placeholder="Select" [(ngModel)]="selectedTraining"
                            (closed)="trainingsSearchText=''" (click)="focusSearch('focus-trainings-search')">
                            <input type="search" id="focus-trainings-search" class="dropdownsearchstyle"
                                [(ngModel)]="trainingsSearchText" matInput placeholder="search">
                            <mat-option [value]="null" class="unselectStyle"
                                (onSelectionChange)="onTrainingSelect($event,null);">Un-select</mat-option>
                            <mat-option *ngFor="let item of trainingDropDown | assessmentSearch : trainingsSearchText"
                                (onSelectionChange)="onTrainingSelect($event,item)" [value]="item.valueExp">
                                {{ item.displayExp }}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>
            </div>
        </ng-container>
    </div> <br>

    <div class="search-button-continer btn-align" mat-dialog-actions
        *ngIf=" (selectedTrailCriteria == 'Training Master' && (pickedTraining && (pickedTraining | json) !== '{}')) || (selectedTrailCriteria != 'Training Master' && ((pickedUser && (pickedUser | json) !== '{}') && selectedTraining))">
        <button mat-stroked-button class=" searchButton" (click)="execute()">
            <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="reset-button" (click)="primaryReset()">
            <i class=" fas fa-undo"></i> Reset
        </button>
    </div>
</div>

<div class="result">
    <mat-tab-group
        *ngIf="selectedTrailCriteria == 'Training Master' && pickedTraining && (pickedTraining | json) !== '{}'"
        selectedIndex="0" mat-stretch-tabs class="activitytab mat-tab-container mat-elevation-z4"
        animationDuration="0ms" (selectedTabChange)="onTabChanged($event);" [(selectedIndex)]="selectedTabIndex">
        <mat-tab *ngFor="let tab of tabs" label='{{tab.tab_name}}'>
            <ng-template mat-tab-label>
                <span> <i class='{{tab.tab_icon}}' style="font-size: 18px;" aria-hidden="true"></i> </span>&nbsp;
                <span>{{tab.tab_name}}</span>
            </ng-template>
            <div class="position-relative grid-content">
                <div>
                    <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center px-3">
                            <div class="dropdown">
                            </div>
                        </div>
                        <div class="d-flex gap-3">
                            <div id="header-container">
                                <div class="">
                                    <div class="search-container">
                                        <span class="fa fa-search form-control-feedback"></span>
                                        <input type="text" class="form-control search_input" style="font-size: 12px"
                                            placeholder="Search here..." [(ngModel)]="searchValue" />
                                    </div>
                                </div>
                            </div>
                            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                                (click)="openReportPopup('Excel')">
                                <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                                <span class="reload_text text-white">Excel Report</span>
                            </div>
                            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                                (click)="openReportPopup('Pdf')">
                                <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                                <span class="reload_text text-white">PDF Report</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="table-container static-scroll">
                    <table class="dynamic-table-container" aria-describedby="table-description">
                        <th style="min-width: 60px; text-align: center;"
                            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                            <div style="display: flex;">
                                <div>
                                    <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                            </div>
                        </th>
                        <th id="grid-header-container"
                            *ngFor="let columnData of columnListsAuditTrails.fieldColumnarray; let ix = index;"
                            [ngStyle]="{'min-width': columnData.width,'max-width': columnData.width,'overflow': 'hidden',
                        'text-overflow': 'ellipsis',
                        'white-space': 'nowrap'}" class="sticky-dynamic-col1" (mouseover)="css(0)">
                            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                                <span>{{ columnData.fieldColumnarray }}</span>
                                <div class="d-flex gap-2 align-items-center">
                                    <div>
                                        <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
                                            alt="sort" />
                                    </div>
                                </div>
                            </div>
                        </th>
                        <th id="menu" class="sticky-col first-col"></th>
                        <tr>
                            <td [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
                            <td *ngFor=" let columnData of columnListsAuditTrails.fieldColumnarray; let ix = index "
                                [ngStyle]="{ 'min-width': columnData.width != null ? columnData.width : '200px' }"
                                class="sticky-dynamic-col1" (mouseover)="css(0)">
                                <div class="row-search-container"><input type="text" class="form-control"
                                        placeholder="Search"
                                        (input)="applyFilter3(columnListsAuditTrails.columnsListarray[ix],$event)">
                                </div>
                            </td>
                        </tr>
                        <tr *ngFor="let list of pagedItems; let idx = index;">
                            <td style="min-width: 60px; text-align: center;"
                                [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                                <div style="display: flex;">
                                    <div [ngClass]="list.childCheckBox ?'static_icon':'hover-menu-icons'">
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </div>
                                </div>
                            </td>
                            <td id="grid-row-container"
                                *ngFor="let key of columnListsAuditTrails.columnsListarray1; let i = index;"
                                class="sticky-dynamic-row1" (mouseover)="css(i)"
                                [ngClass]="list.differColumn.includes(key.columnsListarray) ?'audit-bg-highlight':''"
                                [ngStyle]="{'min-width': key.width !=null ? key.width[i] :'200px','max-width': key.width !=null ? key.width[i] :'200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                                <span *ngIf="key.dataType=='CHECKBOX'">
                                    <div class="gridCheckBoxes">
                                        <img *ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg"
                                            alt="Yes" width="20" height="20">
                                        <img *ngIf="list[key.columnsListarray]==false"
                                            src="../../assets/img/noAcessSymbol.svg" alt="No" width="20" height="20">
                                    </div>

                                </span>
                                <span
                                    *ngIf="list[key.columnsListarray]=='fileIspresentsa' || list[key.columnsListarray]=='fileIsNotpresentsa'">
                                    <div class="download-button-continer btn-align" mat-dialog-actions>
                                        <button class="d-flex align-items-center" mat-stroked-button
                                            class="downloadButton"
                                            (click)="downloadDocuments(list,key.columnsListarray)">
                                            <img src="../../../assets/img/cr_module/download.svg" width="12px"
                                                height="12px" alt="download">
                                            <span class="ms-1">View</span>
                                        </button>
                                    </div>
                                </span>

                                <span
                                    *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
                                    <div class="download-button-continer btn-align" mat-dialog-actions>
                                        <button class="d-flex align-items-center" mat-stroked-button
                                            class="downloadButton" (click)="getClobData(list,key.columnsListarray)">
                                            <img src="../../../assets/img/cr_module/download.svg" width="12px"
                                                height="12px" alt="download">
                                            <span class="ms-1">View</span>
                                        </button>
                                    </div>
                                </span>

                                <span
                                    *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && !(key.columnsListarray=='TEMPLATE' && key.dataType=='textbox') &&  key.columnsListarray != 'QMS_ROLES' && key.columnsListarray != 'DESCRIPTION' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' && list[key.columnsListarray] !='htmlClobView'">
                                    {{
                                    list[key.columnsListarray] === 'U' ? 'Updated' :
                                    list[key.columnsListarray] === 'ID' ? 'Created and Deleted' :
                                    list[key.columnsListarray] === 'UD' ? 'Updated and Deleted' :
                                    list[key.columnsListarray] === 'I' ? 'Created' :
                                    list[key.columnsListarray]
                                    }}
                                </span>
                                <span
                                    *ngIf="key.columnsListarray == 'QMS_ROLES' || key.columnsListarray == 'DESCRIPTION'">
                                    <div class="download-button-continer btn-align" mat-dialog-actions>
                                        <button class="d-flex align-items-center" mat-stroked-button
                                            class="downloadButton"
                                            (click)="staticClobView(key.columnsListarray, list[key.columnsListarray])">
                                            <img src="../../../assets/img/cr_module/download.svg" width="12px"
                                                height="12px" alt="download">
                                            <span class="ms-1">View</span>
                                        </button>
                                    </div>
                                </span>
                                <span *ngIf=" key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
                            </td>
                        </tr>
                    </table>
                    <div class=" d-flex justify-content-center">
                        <div class="width-cheat small paginationCell">
                            <div class="d-flex align-items-center gap-3">
                                <div class="pagination_text mt-3">
                                    {{ showingRowsText }}
                                    1-{{ perPage }} of {{ collectionSize | number }}
                                </div>
                                <div>
                                    <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)"
                                        [disabled]="false" [collectionSize]="pager.totalItems"
                                        [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                                        [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                                    </ngb-pagination>
                                </div>
                                <div ngbDropdown class="mt-3">
                                    <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text"
                                        id="dropdownBasic1" ngbDropdownToggle>
                                        {{ perPage }}
                                        <i class="ms-1 fa-solid fa-chevron-down"></i>
                                    </button>
                                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                        <button ngbDropdownItem (click)="pagination(10)">10</button>
                                        <button ngbDropdownItem (click)="pagination(20)">20</button>
                                        <button ngbDropdownItem (click)="pagination(50)">50</button>
                                    </div>
                                    per page
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>

    <ng-container *ngIf="selectedTrailCriteria != 'Training Master' && selectedTraining">
        <div class="position-relative grid-content">
            <div>
                <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center px-3">
                        <div class="dropdown">
                        </div>
                    </div>
                    <div class="d-flex gap-3">
                        <div id="header-container">
                            <div class="">
                                <div class="search-container">
                                    <span class="fa fa-search form-control-feedback"></span>
                                    <input type="text" class="form-control search_input" style="font-size: 12px"
                                        placeholder="Search here..." [(ngModel)]="searchValue" />
                                </div>
                            </div>
                        </div>
                        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                            (click)="openReportPopup('Excel')">
                            <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                            <span class="reload_text text-white">Excel Report</span>
                        </div>
                        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                            (click)="openReportPopup('Pdf')">
                            <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                            <span class="reload_text text-white">PDF Report</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-container static-scroll">
                <table class="dynamic-table-container" aria-describedby="table-description">
                    <th style="min-width: 60px; text-align: center;"
                        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                        <div style="display: flex;">
                            <div>
                                <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                            </div>
                        </div>
                    </th>
                    <th id="grid-header-container"
                        *ngFor="let columnData of columnListsAuditTrails.fieldColumnarray; let ix = index;" [ngStyle]="{'min-width': columnData.width,'max-width': columnData.width,'overflow': 'hidden',
                    'text-overflow': 'ellipsis',
                    'white-space': 'nowrap'}" class="sticky-dynamic-col1" (mouseover)="css(0)">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                            <span>{{ columnData.fieldColumnarray }}</span>
                            <div class="d-flex gap-2 align-items-center">
                                <div>
                                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
                                        alt="sort" />
                                </div>
                            </div>
                        </div>
                    </th>
                    <th id="menu" class="sticky-col first-col"></th>
                    <tr>
                        <td [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
                        <td *ngFor=" let columnData of columnListsAuditTrails.fieldColumnarray; let ix = index "
                            [ngStyle]="{ 'min-width': columnData.width != null ? columnData.width : '200px' }"
                            class="sticky-dynamic-col1" (mouseover)="css(0)">
                            <div class="row-search-container"><input type="text" class="form-control"
                                    placeholder="Search"
                                    (input)="applyFilter3(columnListsAuditTrails.columnsListarray[ix],$event)">
                            </div>
                        </td>
                    </tr>
                    <tr *ngFor="let list of pagedItems; let idx = index;">
                        <td style="min-width: 60px; text-align: center;"
                            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                            <div style="display: flex;">
                                <div [ngClass]="list.childCheckBox ?'static_icon':'hover-menu-icons'">
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                            </div>
                        </td>
                        <td id="grid-row-container"
                            *ngFor="let key of columnListsAuditTrails.columnsListarray1; let i = index;"
                            class="sticky-dynamic-row1" (mouseover)="css(i)"
                            [ngClass]="list.differColumn.includes(key.columnsListarray) ?'audit-bg-highlight':''"
                            [ngStyle]="{'min-width': key.width !=null ? key.width[i] :'200px','max-width': key.width !=null ? key.width[i] :'200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                            <span *ngIf="key.dataType=='CHECKBOX'">
                                <div class="gridCheckBoxes">
                                    <img *ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg"
                                        alt="Yes" width="20" height="20">
                                    <img *ngIf="list[key.columnsListarray]==false"
                                        src="../../assets/img/noAcessSymbol.svg" alt="No" width="20" height="20">
                                </div>

                            </span>
                            <span
                                *ngIf="list[key.columnsListarray]=='fileIspresentsa' || list[key.columnsListarray]=='fileIsNotpresentsa'">
                                <div class="download-button-continer btn-align" mat-dialog-actions>
                                    <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                                        (click)="downloadDocuments(list,key.columnsListarray)">
                                        <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px"
                                            alt="download">
                                        <span class="ms-1">View</span>
                                    </button>
                                </div>
                            </span>

                            <span
                                *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
                                <div class="download-button-continer btn-align" mat-dialog-actions>
                                    <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                                        (click)="getClobData(list,key.columnsListarray)">
                                        <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px"
                                            alt="download">
                                        <span class="ms-1">View</span>
                                    </button>
                                </div>
                            </span>

                            <span
                                *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && !(key.columnsListarray=='TEMPLATE' && key.dataType=='textbox') &&  key.columnsListarray != 'QMS_ROLES' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' && list[key.columnsListarray] !='htmlClobView'">
                                {{
                                list[key.columnsListarray] === 'U' ? 'Updated' :
                                list[key.columnsListarray] === 'ID' ? 'Created and Deleted' :
                                list[key.columnsListarray] === 'UD' ? 'Updated and Deleted' :
                                list[key.columnsListarray] === 'I' ? 'Created' :
                                list[key.columnsListarray]
                                }}
                            </span>
                            <span *ngIf=" key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
                        </td>
                    </tr>
                </table>
                <div class=" d-flex justify-content-center">
                    <div class="width-cheat small paginationCell">
                        <div class="d-flex align-items-center gap-3">
                            <div class="pagination_text mt-3">
                                {{ showingRowsText }}
                                1-{{ perPage }} of {{ collectionSize | number }}
                            </div>
                            <div>
                                <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)"
                                    [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                                    [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
                                    [boundaryLinks]="true" size="sm">
                                </ngb-pagination>
                            </div>
                            <div ngbDropdown class="mt-3">
                                <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1"
                                    ngbDropdownToggle>
                                    {{ perPage }}
                                    <i class="ms-1 fa-solid fa-chevron-down"></i>
                                </button>
                                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                    <button ngbDropdownItem (click)="pagination(10)">10</button>
                                    <button ngbDropdownItem (click)="pagination(20)">20</button>
                                    <button ngbDropdownItem (click)="pagination(50)">50</button>
                                </div>
                                per page
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>

<ng-template #searchTraining>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="closeSearchPopup('Training(s)')" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ searchPopupTitle }} </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="search-popup">
        <div class="row">
            <div class="col-md-3">
                <div><label for="email">Training Name</label></div>
                <input class="search-filed-continers" type="text" [(ngModel)]="trainingNameSearch">
            </div>
            <div class="col-md-3">
                <div><label for="email">Training Code</label></div>
                <input class="search-filed-continers" type="text" [(ngModel)]="trainingCodeSearch">
            </div>
            <div class="col-md-3">
                <div><label for="email">Category</label></div>
                <mat-select matInput placeholder="Select" [(ngModel)]="selectedCategory"
                    (closed)="categorySearchText=''" (click)="focusSearch('focus-category-search')">
                    <input type="search" id="focus-category-search" class="dropdownsearchstyle"
                        [(ngModel)]="categorySearchText" matInput placeholder="search">
                    <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
                    <mat-option *ngFor="let item of categoryDropdown | assessmentSearch : categorySearchText"
                        [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-md-3">
                <div><label for="email">Language</label></div>
                <mat-select matInput placeholder="Select" [(ngModel)]="selectedLanguage"
                    (closed)="languageSearchText=''" (click)="focusSearch('focus-language-search')">
                    <input type="search" id="focus-language-search" class="dropdownsearchstyle"
                        [(ngModel)]="languageSearchText" matInput placeholder="search">
                    <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
                    <mat-option *ngFor="let item of languageDropdown | assessmentSearch : languageSearchText"
                        [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
        </div> <br>
        <div class="row">
            <div class="button-continer btn-align" mat-dialog-actions>
                <button mat-stroked-button class="addButton" (click)="searchTrainings()">
                    <i class="fa-solid fa-magnifying-glass"></i> Search
                </button>
                <button mat-stroked-button class="cancelButton" *ngIf="!trainings.length"
                    (click)="closeSearchPopup('Training(s)')">
                    <i class="fa fa-close"></i> Cancel
                </button>
                <button mat-stroked-button class="cancelButton"
                    *ngIf="trainingNameSearch || trainingCodeSearch || selectedCategory || selectedLanguage || trainings.length"
                    (click)="reset()">
                    <i class="fas fa-undo"></i> Reset
                </button>
            </div>
        </div>
        <div class="table-container" *ngIf="trainings.length">
            <table style="max-height: 50vh;">
                <thead>
                    <th style="min-width: 60px; text-align: center;">
                        <div style="display: flex;">
                            <div>
                                <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                            </div>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Training Name</span>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Training Code</span>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Version</span>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Category</span>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Training Type</span>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Language</span>
                        </div>
                    </th>

                    <th id="menu" class="sticky-col first-col"></th>
                </thead>
                <tbody>
                    <tr class="data-row-container" *ngFor="let training of trainings; let idx = index;">
                        <td style="min-width: 80px; text-align: center;">
                            <div style="display: flex;">
                                <div [ngClass]="training.trainingChildCheckBox ?'static_icon':'hover-menu-icons'">
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                                <div style="margin-left: 5px;">
                                    <input id="selectedUserCheckBox" type="checkbox" style="zoom: 1.2;"
                                        [checked]="training.trainingChildCheckBox"
                                        (change)="onChildChecked($event, training)">
                                </div>
                            </div>
                        </td>
                        <td class="row-data">{{ training.trainingName }}</td>
                        <td class="row-data">{{ training.trainingCode }}</td>
                        <td class="row-data">{{ training.version }}</td>
                        <td class="row-data">{{ training.categoryCode }}</td>
                        <td class="row-data">{{ training.type }}</td>
                        <td class="row-data">{{ training.language }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions *ngIf="trainings.length">
        <button mat-stroked-button class="addButton"
            [ngStyle]="{ 'cursor': draftTraining && (draftTraining | json) == '{}' ? 'not-allowed' : 'pointer', 'pointer-events': 'auto' }"
            (click)="pick()" [disabled]="draftTraining && (draftTraining | json) == '{}'">
            <i class="fas fa-check"></i> Pick
        </button>

        <button mat-stroked-button class="cancelButton" (click)="closeSearchPopup('Training(s)')">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>

<ng-template #searchUser>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="closeSearchPopup('User(s)')" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> Search User(s)</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="search-popup">
        <div class="row">
            <div class="col-md-4">
                <div><label for="email">User Name</label></div>
                <input class="search-filed-continers" type="text" [(ngModel)]="userNameSearch">
            </div>
            <div class="col-md-4">
                <div><label for="email">First Name</label></div>
                <input class="search-filed-continers" type="text" [(ngModel)]="firstNameSearch">
            </div>
            <div class="col-md-4">
                <div><label for="email">Last Name</label></div>
                <input class="search-filed-continers" type="text" [(ngModel)]="lastNameSearch">
            </div>
            <div class="col-md-4">
                <div><label for="email">Email</label></div>
                <input class="search-filed-continers" type="email" [(ngModel)]="emailSearch">
                <div id="email-val-icon" class="field-icon-container"></div>
            </div>
            <div class="col-md-4">
                <div><label for="email">Designation</label></div>
                <mat-select matInput placeholder="Select" [(ngModel)]="selectedDesignation"
                    (closed)="designationSearchText=''" (click)="focusSearch('focus-designation-search')">
                    <input type="search" id="focus-designation-search" class="dropdownsearchstyle"
                        [(ngModel)]="designationSearchText" matInput placeholder="search">
                    <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
                    <mat-option *ngFor="let item of designationDropdown | assessmentSearch : designationSearchText"
                        [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-md-4">
                <div><label for="email">Department</label></div>
                <mat-select matInput placeholder="Select" [(ngModel)]="selectedDepartment"
                    (closed)="departmentSearchText=''" (click)="focusSearch('focus-department-search')">
                    <input type="search" id="focus-department-search" class="dropdownsearchstyle"
                        [(ngModel)]="departmentSearchText" matInput placeholder="search">
                    <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
                    <mat-option *ngFor="let item of departmentDropdown | assessmentSearch : departmentSearchText"
                        [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
        </div>
        <div class="row">
            <div class="button-continer btn-align" mat-dialog-actions>
                <button mat-stroked-button class="addButton" (click)="searchUsers()">
                    <i class="fa-solid fa-magnifying-glass"></i> Search
                </button>
                <button mat-stroked-button class="cancelButton" *ngIf="!users.length"
                    (click)="closeSearchPopup('User(s)')">
                    <i class="fa fa-close"></i> Cancel
                </button>
                <button mat-stroked-button class="cancelButton"
                    *ngIf="userNameSearch || firstNameSearch || lastNameSearch || emailSearch || selectedDesignation || selectedDepartment || users.length"
                    (click)="reset()">
                    <i class="fas fa-undo"></i> Reset
                </button>
            </div>
        </div>
        <div class="table-container" *ngIf="users.length">
            <table style="max-height: 45vh;">
                <thead>
                    <th style="min-width: 60px; text-align: center;">
                        <div style="display: flex;">
                            <div>
                                <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                            </div>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>User Name</span>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>First Name</span>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Last Name</span>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Email</span>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Designation</span>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Department</span>
                        </div>
                    </th>

                    <th id="grid-header-container"
                        [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Manager Name</span>
                        </div>
                    </th>

                    <th id="menu" class="sticky-col first-col"></th>
                </thead>
                <tbody>
                    <tr class="data-row-container" *ngFor="let user of users; let idx = index;">
                        <td style="min-width: 80px; text-align: center;">
                            <div style="display: flex;">
                                <div [ngClass]="user.userChildCheckBox ?'static_icon':'hover-menu-icons'">
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                                <div style="margin-left: 5px;">
                                    <input id="selectedUserCheckBox`" type="checkbox" style="zoom: 1.2;"
                                        [checked]="user.userChildCheckBox" (change)="onChildChecked($event, user)">
                                </div>
                            </div>
                        </td>
                        <td class="row-data">{{ user.userName }}</td>
                        <td class="row-data">{{ user.firstName }}</td>
                        <td class="row-data">{{ user.lastName }}</td>
                        <td class="row-data">{{ user.emailAddress }}</td>
                        <td class="row-data">{{ user.designation }}</td>
                        <td class="row-data">{{ user.department }}</td>
                        <td class="row-data">{{ user.managerName }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="button-continer btn-align" mat-dialog-actions *ngIf="users.length">
            <button mat-stroked-button class="addButton" (click)="pick()"
                [disabled]="draftUser && (draftUser | json) == '{}'">
                <i class="fas fa-check"></i> Pick
            </button>
            <button mat-stroked-button class="cancelButton" (click)="closeSearchPopup('User(s)')">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #excelPdfPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{reportPopupTitle}} </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;" class="center">
        <label for="email" style="font-size: medium; font-weight: bold;">
            Do you want to generate {{reportPopupTitle}} ?</label>
    </div>
    <div style="margin: 15px 15px;" class="center" *ngIf="!isForExcel">
        <label for="email" style="font-size: .7rem; font-weight: bold;">
            <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
            <span *ngIf="manuallyPicked && maxCountReached">
                We recommend selecting a maximum of 10 fields for a cleaner and more readable PDF
            </span>
        </label>
    </div>

    <div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
        <div class="col-md-12" *ngIf="selectedColumns.length">
            <div><label for="email">Selected Column(s)</label></div>
            <textarea id="selectedValuesTextarea" class="input-filed-textarea"
                style="margin-top: 8px; cursor: not-allowed;" rows="4" cols="50" [disabled]="true"
                [(ngModel)]="selectedColumnsAsString"></textarea>
        </div>

        <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
            <div class="col-md-6">
                <label for="radio">PDF Page Size</label>
                <mat-radio-group [(ngModel)]="pdfPageSize">
                    <mat-radio-button *ngFor="let data of pdfPageSizes"
                        [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="col-md-6" style="margin-top: 1.5%;">
                <label for="toggle">Pick Columns Manually?</label>&nbsp;
                <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked"
                    id="toggle">
                    <ng-container *ngIf="manuallyPicked; else no">
                        <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                    </ng-container>
                    <ng-template #no>
                        <span style="color: red;">No</span>
                    </ng-template>
                </mat-slide-toggle>
            </div>
        </div>

        <div class="row mt-3" *ngIf="manuallyPicked">
            <div class="col-md-12">
                <div><label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span></div>
                <mat-select matInput multiple placeholder="Select" #columns [(ngModel)]="selectedColumns"
                    (closed)="columnSearchText=''" (click)="focusSearch('focus-column-search')">
                    <input type="search" id="focus-column-search" class="dropdownsearchstyle"
                        [(ngModel)]="columnSearchText" matInput placeholder="search">
                    <div class="select-all">
                        <mat-checkbox [(ngModel)]="isAllColumns" (change)="toggleAllSelection('columns')">
                            Select All</mat-checkbox>
                    </div>
                    <mat-option *ngFor="let item of dropDownForPdfColumn | multiAssessmentSearchPipe : columnSearchText"
                        [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
        </div>
    </div>

    <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
        <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Excel')">
            <i class="fa fa-file-excel-o"></i> Generate
        </button>
        <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
            <i class="fa fa-file-pdf-o"></i> Generate
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>

<ng-template #pdfViewerPopup>
    <button class="close close-button" (click)="cancelPdfViewer()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div id="viewerHideShow" #viewer style="height: 96%; margin-top: 5px"></div>
</ng-template>

<ng-template #imageViewerPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>

    <button class="close close-button" (click)="cancelImageViewer()" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>

    <div mat-dialog-title>
        <label class="popupTitle" matTooltip="{{imageViewerTitle}}">
            {{ imageViewerTitle }}
        </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>

    <div class="row" style="padding:5px;">
        <div class="col-sm-12">
            <img id="picturewe" src="" height="85vh" width="100%" alt="view"
                style="overflow: hidden; height: 85vh; width: 100%; object-fit: contain;" />
        </div>
    </div>
</ng-template>

<ng-template #angularEditor>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAngularEditor()" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{editorTitle}} </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <br>
    <div class="row">
        <div class="col-md-12 st-editor">
            <st-editor [(ngModel)]="editorNgModel" [config]="disabled" [spellcheck]="true"></st-editor>
        </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="cancelButton" (click)="cancelAngularEditor()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>

<app-editor #clobViewPopup></app-editor>
<app-document-viewer #viewPopup [docViewer]="docViewer" *ngIf="docViewer?.doc"></app-document-viewer>